import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCreditScoreDetailsContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CreditScoreDetailsContainer" */
                '@perpay-web/fintech/components/containers/CreditScoreDetailsContainer'
            ),
    );
